export default __webpack_public_path__ + "media/apps/Configurator/images/Flex-U-Build-Options-496de0bc52d6a3db31bceecf41861603.png";